import styled from 'styled-components';

const HeaderStyles = styled.header`
      background-image: url('https://i.imgur.com/EHzvNok.jpg');
      height: 369px;
      background-size: cover;
      background-position: center;
`;

export default HeaderStyles;